import { SCENE_TYPE, PREVIEW_TYPE } from '~/shared/constants'
import type { GalleryDesignsCurrentColorSwatch } from 'shared/types/gallery/designs'

const EMPTY_SCENES = {
  [PREVIEW_TYPE.TILE]: {
    uri: '',
    sceneType: 'default' as SCENE_TYPE,
  },
  [PREVIEW_TYPE.QUICKVIEW]: {
    uri: '',
    sceneType: 'default' as SCENE_TYPE,
  },
}

const EMPTY_PREVIEW_INFO = {
  scenes: EMPTY_SCENES,
  templateToken: '',
  finishType: '',
  designId: '',
  dps: '',
}

export const getDefaultColorSwatch = (designId: string, previewType: PREVIEW_TYPE): GalleryDesignsCurrentColorSwatch => ({
  color: '',
  colorSwatches: [],
  designId,
  previewType,
  renderablePreviews: {
    previewInfo: EMPTY_PREVIEW_INFO,
    previewWidth: 0,
    previewsUrls: {
      size1x: '',
      size2x: '',
    },
  },
  previewUrls: {
    size1x: '',
    size2x: '',
  },
  isLightColor: false,
  externalId: '',
  designColors: [],
  colorComposition: [],
  studioUrl: 'https://www.vistaprint.com',
  previewInfo: EMPTY_PREVIEW_INFO,
  nonPersonalizedStudioUrl: 'https://www.vistaprint.com',
  nonPersonalizedPreviewUrls: {
    size1x: '',
    size2x: '',
  },
})
